import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'listFilter'
})
export class ListFilterPipe implements PipeTransform {
  transform(list: any[], filterText: string, ...args: string[]): any[] {
    return (list || []).filter(item => this.checkConstrain(item, filterText, args));
  }

  private checkConstrain = (item: any, filterText: string, args: string[]): boolean => {
    for (let x = 0; x < args.length; x++) {
      let searchValue = (this.getValue(item, args[x]) || '').toString();

      if (searchValue.search(new RegExp(filterText, 'i')) > -1)
        return true;
    }

    return false;
  }

  private getValue = (item: any, arg: string): any => {
    if (!item)
      return null;

    let value = null;
    const args = arg.split('.');

    for (let x = 0; x < args.length; x++) {
      if (x > 0) {
        if (value)
          value = value[args[x]];
        else
          return null;
      }
      else
        value = item[args[x]];
    }

    return value;
  }
}